import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';

export const OcurrencesAnual = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    const series = [
        {
            name: 'Total',
            data: chartData?.ocurrencesAnual?.map(item => item.total)
        },
        {
            name: 'Madrugada',
            data: chartData?.ocurrencesAnual?.map(item => item.horario_madrugada)
        },
        {
            name: 'Manhã',
            data: chartData?.ocurrencesAnual?.map(item => item.horario_manha)
        },
        {
            name: 'Tarde',
            data: chartData?.ocurrencesAnual?.map(item => item.horario_tarde)
        },
        {
            name: 'Noite',
            data: chartData?.ocurrencesAnual?.map(item => item.horario_noite)
        },
        {
            name: 'Não Identificado',
            data: chartData?.ocurrencesAnual?.map(item => item.horario_nao_identificado)
        }
    ];

    const categories = chartData?.ocurrencesAnual?.map(item => getYearLabel(item.ano));

    return (
        <SimpleBars
            title={'Período das Ocorrências (Anual)'}
            horizontal={false}
            stacked
            subtitles={categories}
            series={series}
            showDataLabels={false}
        />
    );
};
